import React from "react";
import Tag from "../../../components/Tag";
import TableCell from "../../../components/SmartTable/TableCell";
import { PERMISSION_VIEW_CORE_NOTIFICATIONS } from "../../../components/_auth/permissions/permissions";
import DeleteItemButton from "../../../components/SmartTable/TableFiltersActions/DeleteItemButton";
import NotificationsMessageColumn from "./NotificationsMessageColumn";
import MarkAsSeen from "./MarkAsSeen";

export const TABLE_NOTIFICATIONS_NAME = "table-notifications";

const MODULE_TAG_CLASS = {
  TRG: "tag-primary",
  DOM: "tag-secondary",
  ADM: "tag-warning"
};

export const generateColumns = (permission, trans, updateNotificationsState) => {
  return [
    {
      title: "container.notifications_page.message",
      dataIndex: "message",
      render: (text, row) => (
        <TableCell>
          <NotificationsMessageColumn data={row} />
        </TableCell>
      )
    },
    {
      title: trans("container.notifications_page.module"),
      dataIndex: "module",
      width: 120,
      render: (text, row) =>
        row.module ? (
          <TableCell>
            <Tag className={MODULE_TAG_CLASS[row.module]}>{row.module}</Tag>
          </TableCell>
        ) : (
          <TableCell>-</TableCell>
        )
    },
    ...(permission.canDo(PERMISSION_VIEW_CORE_NOTIFICATIONS)
      ? [
          {
            title: trans("container.notifications_page.generation_date"),
            fixed: "right",
            width: 150,
            render: (row = {}) => <div className="table-actions-column">{row.generation_date}</div>
          },
          {
            title: trans("container.general_words.actions"),
            fixed: "right",
            width: 80,
            render: (row = {}) => (
              <div className="table-actions-column">
                <MarkAsSeen notification={row} onSuccess={updateNotificationsState} />
                <DeleteItemButton
                  onDelete={updateNotificationsState}
                  tableName={TABLE_NOTIFICATIONS_NAME}
                  route={`notifications/${row.id}`}
                  content={
                    <div>
                      <div>{trans("container.confirm_modal.form_subtitle")}</div>
                    </div>
                  }
                />
              </div>
            )
          }
        ]
      : [])
  ];
};
